import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { withLatestFrom, mergeMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { getReaderApi } from '../state/configuration/configuration.selectors';
import { getToken } from '../../state/session/session.selectors';

@Injectable()
export class ReaderApiAuthInterceptor implements HttpInterceptor {
  constructor(private readonly store: Store) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return of(req.url).pipe(
      withLatestFrom(
        this.store.select(getReaderApi),
        this.store.select(getToken),
      ),
      mergeMap(([url, readerApi, accessToken]) => {
        const skip = req.headers.has('X-Skip-Interceptor');
        // Only attach the session access token to reader-api calls; exclude token requests
        if (url.includes(readerApi) && !skip && accessToken) {
          req = req.clone({
            headers: req.headers.set('Authorization', `Bearer ${accessToken}`),
          });
        }

        return next.handle(req);
      }),
    );
  }
}
